import React from "react";
import { Controller } from "react-hook-form";
import { MenuItem, TextField } from "@mui/material";
import {
  ROW_TYPE_OPTIONS,
  resolveScheduleType,
} from "../utils/scheduleEditorMapping";

export default function RowTypeField({
  selectedScheduleType,
  control,
  errors,
  companyType = "common",
  disabled = false,
  required = false,
}) {
  const scheduleType = resolveScheduleType(selectedScheduleType, companyType);
  const options = ROW_TYPE_OPTIONS[scheduleType];

  if (!options) return null;

  return (
    <Controller
      name='rowType'
      control={control}
      rules={{
        required: required ? "Please select a row type." : false,
      }}
      render={({ field }) => (
        <TextField
          {...field}
          select
          fullWidth
          label='Row Type'
          size='small'
          disabled={disabled}
          required={required}
          error={Boolean(errors.rowType)}
          helperText={errors.rowType?.message || ""}
        >
          <MenuItem value=''>
            <em>Select a row type</em>
          </MenuItem>
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
}
